import Model from './Model'
import OperativePlanning from './OperativePlanning'

export default class OperativePlanningBooking extends Model {
    key() {
        return this.id
    }

    async markOperativePresent(operativePlanningItem) {
        const url = route('api.v1.packages.operative-planning.mark-booking-present', this.package_id)
        const {data} = await Http.put(url, {
            person_id: this.id,
            date: this.date,
        })

        return operativePlanningItem.fill(data)
    }

    async saveNote() {
        const url = route('api.v1.packages.operative-planning.save-note', this.package_id)
        const {data} = await Http.put(url, {
            person_id: this.id,
            date: this.date,
            note: this.note,
        })
        return OperativePlanning.make(data)
    }

    async markOperativeAbsent(operativePlanningItem) {
        const url = route('api.v1.packages.operative-planning.mark-booking-absent', this.package_id)
        const {data} = await Http.put(url, {
            person_id: this.id,
            date: this.date,
        })

        return operativePlanningItem.fill(data)
    }
}
